"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchLoggingBlacklist = void 0;

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _immutable = require("immutable");

var emailBlacklistApiBase = '/engagements-emails/v1/blacklist';

var fetchLoggingBlacklist = function fetchLoggingBlacklist() {
  return (0, _ImmutableAPI.get)("" + emailBlacklistApiBase, {
    portalId: _hubspot.default.get()
  }).then(function (neverlogList) {
    return (0, _immutable.Map)({
      neverlogList: neverlogList
    });
  });
};

exports.fetchLoggingBlacklist = fetchLoggingBlacklist;